'use client';

import type { ReactNode } from 'react';

import { IoAlertCircleOutline, IoShieldCheckmark } from 'react-icons/io5';

import { IconTooltip } from '../../tooltip';

import styles from './InfoIcons.module.scss';

/** Marks an assessment as one that was really sat, rather than one written for practice. */
function OfficialIcon({ placement = 'top' }: { placement?: 'top' | 'bottom' }) {
  return (
    <IconTooltip
      icon={<IoShieldCheckmark />}
      label="Examen oficial"
      placement={placement}
      className={styles['icon']}
    />
  );
}

/** Carries whatever is worth knowing about a question beyond the question itself. */
function TipIcon({ children }: { children: ReactNode }) {
  return (
    <IconTooltip
      icon={<IoAlertCircleOutline />}
      label="Tip"
      className={styles['icon']}
    >
      {children}
    </IconTooltip>
  );
}

export { OfficialIcon, TipIcon };
